export default {
  CANCEL_STRAIGHT_DOWN: 0,
  SET_TO_TERM: 1,
  COLLECT_OVERDUE: 2,
  COLLECT_DS_FEE: 3,
  COLLECT_CANCELLATION_FEE: 4,
  WITH_NOTICE_PERIOD: 5,
  CHARGE_BACK_DS_FEE: 6,
};
